
import React from 'react';

const StatsSection: React.FC = () => {
  const stats = [
    {
      number: '9+',
      label: 'Years Experience',
      icon: 'ri-calendar-line',
      color: 'bg-green-600'
    },
    {
      number: '500+',
      label: 'Projects Completed',
      icon: 'ri-hammer-line',
      color: 'bg-blue-600'
    },
    {
      number: '25',
      label: 'Service Areas',
      icon: 'ri-map-pin-line',
      color: 'bg-orange-600'
    },
    {
      number: '100%',
      label: 'Customer Satisfaction',
      icon: 'ri-heart-line',
      color: 'bg-red-600'
    }
  ];

  return (
    <section className="py-16 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {stats.map((stat, index) => (
            <div key={index} className="text-center">
              <div className={`${stat.color} w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4`}>
                <i className={`${stat.icon} text-2xl text-white`}></i>
              </div>
              <div className="text-4xl font-bold text-gray-800 mb-2">{stat.number}</div>
              <div className="text-gray-600 font-medium">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default StatsSection;
